export var MatrixMatrixOpType;
(function (MatrixMatrixOpType) {
    MatrixMatrixOpType["ADD"] = "ADD";
    MatrixMatrixOpType["SUB"] = "SUB";
    MatrixMatrixOpType["MULT"] = "MULT";
})(MatrixMatrixOpType || (MatrixMatrixOpType = {}));
export var MatrixOpType;
(function (MatrixOpType) {
    MatrixOpType["SQUARE"] = "SQUARE";
    MatrixOpType["INVERSE"] = "INVERSE";
    MatrixOpType["TRANSPOSE"] = "TRANSPOSE";
    MatrixOpType["NORM"] = "NORM";
    MatrixOpType["COLUMN_NORM"] = "COLUMN_NORM";
})(MatrixOpType || (MatrixOpType = {}));
export var MatrixScalarOpType;
(function (MatrixScalarOpType) {
    MatrixScalarOpType["SCALARMULT"] = "SCALARMULT";
    MatrixScalarOpType["SCALARADD"] = "SCALARADD";
    MatrixScalarOpType["SCALARPOW"] = "SCALARPOW";
})(MatrixScalarOpType || (MatrixScalarOpType = {}));
//# sourceMappingURL=types.js.map